import { createRoutesFromElements, Route } from 'react-router-dom'
import { LoginPage } from './components/LoginPage'
import PrivateRouteWrapper from './core/private-route-wrapper'
import { NotFoundPage } from './components/error-pages/NotFoundPage'
// import { LegacyIframesWrapper } from '@reapit-sales/legacy-crm'

export const routes = createRoutesFromElements(
  <Route path="/">
    <Route path="login" element={<LoginPage />} />
    <Route path="/" element={<PrivateRouteWrapper />}>
      {/* <Route element={<LegacyIframesWrapper />}> */}
      <Route
        path="dashboard"
        lazy={async () => (await import('./components/dashboard/routeProps')).CreateDashboardPageRouteProps}
      />
      <Route
        path="properties"
        lazy={async () => (await import('./components/properties/routeProps')).CreatePropertiesPageRouteProps}
      />
      <Route
        path="contacts"
        lazy={async () => (await import('./components/contacts/routeProps')).CreateContactsPageRouteProps}
      />
      <Route
        path="leads"
        lazy={async () => (await import('./components/leads/routeProps')).CreateLeadsPageRouteProps}
      />
      <Route
        path="reports"
        lazy={async () => (await import('./components/reports/routeProps')).CreateReportsPageRouteProps}
      />
      <Route
        path="prospector"
        lazy={async () => (await import('./components/prospector/routeProps')).CreateProspectorPageRouteProps}
      />
      <Route
        path="trust"
        lazy={async () => (await import('./components/trust/routeProps')).CreateTrustPageRouteProps}
      />
      <Route
        path="tasks"
        lazy={async () => (await import('./components/tasks/routeProps')).CreateTasksPageRouteProps}
      />
      <Route
        path="my-office"
        lazy={async () => (await import('./components/office/routeProps')).CreateOfficePageRouteProps}
      />
      <Route path="website" lazy={async () => (await import('./components/cms/routeProps')).CreateCMSPageRouteProps} />
      <Route
        path="litmos-redirect"
        lazy={async () => (await import('./components/litmos/routeProps')).CreateLitmosPageRouteProps}
      />
      {/* </Route> */}
    </Route>
    {/* Add a 404 route */}
    <Route path="*" element={<NotFoundPage />} />
  </Route>,
)
